import React from 'react'

export default function Overlay() {
  return (
    <div className="absolute inset-0 z-10 rounded-sm bg-mauve-50/70 backdrop-blur-[1px]" />
  )
}
